import React, { useState } from 'react';
import { partners } from '../data/mock';
import { Building2, Users, FlaskConical } from 'lucide-react';

const PartnerLogo = ({ partner, className }) => {
  const [imgError, setImgError] = useState(false);

  if (partner.logo && !imgError) {
    return (
      <img 
        src={partner.logo} 
        alt={partner.name}
        className={className}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <span className="text-base font-semibold text-[#0f172a]">
      {partner.name}
    </span>
  );
};

const Partners = () => {
  const featuredPartners = partners.filter(p => p.featured);
  const otherPartners = partners.filter(p => !p.featured);

  const getIcon = (type) => {
    switch(type) {
      case 'Hospital': return Building2;
      case 'Laboratory': return FlaskConical;
      default: return Users;
    }
  };

  return (
    <section className="py-16 bg-white border-y border-[#e2e8f0]">
      <div className="container">
        <div className="text-center mb-10">
          <p className="text-sm uppercase tracking-widest text-[#64748b] font-medium">
            Trusted Collaborations
          </p>
        </div>

        {/* Featured Partners - Larger */}
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-14 mb-10">
          {featuredPartners.map((partner, index) => {
            const content = (
              <PartnerLogo 
                partner={partner} 
                className="h-14 md:h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
              />
            );

            return partner.url ? (
              <a
                key={index}
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-[#475569] hover:text-[#b8860b] transition-colors"
                title={partner.name}
              >
                {content}
              </a>
            ) : (
              <div
                key={index}
                className="flex items-center text-[#475569]"
                title={partner.name}
              >
                {content}
              </div>
            );
          })}
        </div>

        {/* Other Partners */}
        {otherPartners.length > 0 && (
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 pt-6 border-t border-[#e2e8f0]">
            {otherPartners.map((partner, index) => {
              const Icon = getIcon(partner.type);
              const content = (
                <PartnerLogo 
                  partner={partner} 
                  className="h-10 md:h-12 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-80 hover:opacity-100"
                />
              );

              return partner.url ? (
                <a
                  key={index}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-[#64748b] hover:text-[#b8860b] transition-colors"
                  title={partner.name}
                >
                  {content}
                </a>
              ) : (
                <div
                  key={index}
                  className="flex items-center text-[#64748b]"
                  title={partner.name}
                >
                  {content}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default Partners;
